import { supportService } from "./support.service";
import { IInputService, CaretPosition } from "../models/input";

/**
 * Input Service Implementation
 * Provides utilities for input element manipulation.
 
 */
class InputService implements IInputService {
    /**
     * Get or set the caret (text cursor) position in an input element.
     */
    caret(element: HTMLInputElement | HTMLTextAreaElement | JQuery, start?: number, end?: number): CaretPosition {
        let rangeElement: any;
        const isPosition = start !== undefined;

        if (end === undefined) {
            end = start;
        }

        // Unwrap jQuery element
        if ((element as JQuery)[0]) {
            element = (element as JQuery)[0] as HTMLInputElement;
        }

        const inputElement = element as HTMLInputElement | HTMLTextAreaElement;

        if (isPosition && inputElement.disabled) {
            return [];
        }

        try {
            if (inputElement.selectionStart !== undefined) {
                if (isPosition) {
                    inputElement.focus();
                    const mobile = supportService.mobileOS;
                    if (mobile && (mobile.wp || mobile.android)) {
                        // Without the timeout the caret is at the end of the input
                        setTimeout(() => {
                            inputElement.setSelectionRange(start!, end!);
                        }, 0);
                    } else {
                        inputElement.setSelectionRange(start!, end!);
                    }
                    return [start!, end!];
                } else {
                    return [inputElement.selectionStart, inputElement.selectionEnd];
                }
            } else if ((document as any).selection) {
                // Legacy IE support
                if ($(inputElement).is(":visible")) {
                    inputElement.focus();
                }

                rangeElement = (inputElement as any).createTextRange();

                if (isPosition) {
                    rangeElement.collapse(true);
                    rangeElement.moveStart("character", start);
                    rangeElement.moveEnd("character", end! - start!);
                    rangeElement.select();
                    return [start!, end!];
                } else {
                    const rangeDuplicated = rangeElement.duplicate();
                    let selectionStart: number;
                    let selectionEnd: number;

                    rangeElement.moveToBookmark((document as any).selection.createRange().getBookmark());
                    rangeDuplicated.setEndPoint("EndToStart", rangeElement);
                    selectionStart = rangeDuplicated.text.length;
                    selectionEnd = selectionStart + rangeElement.text.length;

                    return [selectionStart, selectionEnd];
                }
            }
        } catch (e) {
            // Element is not focused or it is not in the DOM
            return [];
        }

        return [];
    }

    /**
     * Get anti-forgery (CSRF) tokens from the page.
     */
    antiForgeryTokens(): Record<string, string> {
        const tokens: Record<string, string> = {};

        const csrfToken = $("meta[name=csrf-token],meta[name=_csrf]").attr("content");
        const csrfParam = $("meta[name=csrf-param],meta[name=_csrf_header]").attr("content");

        $("input[name^='__RequestVerificationToken']").each(function(this: HTMLInputElement) {
            tokens[this.name] = this.value;
        });

        if (csrfParam !== undefined && csrfToken !== undefined) {
            tokens[csrfParam] = csrfToken;
        }

        return tokens;
    }
}

export const inputService = new InputService();